import React from 'react'

interface StoreDarazIconProps {
  size?: number | string
  color?: string
  className?: string
}

const StoreDaraz: React.FC<StoreDarazIconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 300 342"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g stroke={color} fill="none" strokeWidth={15}>
      <path d="M111 322.40 c-8.45 -1.40 -17.75 -3.80 -22.75 -5.90 -8.15 -3.35 -12.20 -5.55 -19.10 -10.10 -22.95 -15.30 -38.70 -39.15 -43.55 -65.90 -2.25 -12.15 -2.25 -26.60 -0.05 -37.75 2.55 -12.80 5.85 -21.75 12.05 -32.65 3.55 -6.20 4.65 -7.75 10.55 -14.85 9.45 -11.40 23.35 -21.70 37.10 -27.50 1.10 -0.45 2.45 -1.05 3 -1.30 1.35 -0.55 5.65 -2 7.50 -2.45 12.35 -3.30 13.80 -3.50 25.75 -3.85 8.90 -0.25 15.60 0.20 21 1.40 6.65 1.50 7.50 1.75 12 3.15 6.85 2.15 17.60 7.35 23.75 11.45 l3.50 2.35 0.25 -55.60 0.25 -55.65 20.90 -0.15 20.85 -0.10 0 146.25 0 146.25 -20.85 -0.10 -20.90 -0.15 -0.25 -7.40 -0.25 -7.35 -4 2.65 c-3.70 2.50 -12.35 7.05 -17 8.95 -6.70 2.70 -14.70 4.85 -24.30 6.35 -3.95 0.65 -21.55 0.60 -25.45 -0.05z m24.75 -42.95 c8.80 -2.15 16.45 -5.60 22.55 -10.20 9.30 -6.95 17 -17.45 20.55 -28 1 -2.85 1.35 -4.25 2.60 -9.85 0.70 -3.05 0.70 -16.75 0 -19.80 -1.60 -7.25 -1.90 -8.30 -3.05 -11.10 -0.30 -0.70 -0.70 -1.70 -0.90 -2.25 -1.20 -3.35 -4.60 -9.20 -7.50 -13 -2.90 -3.80 -9.80 -10.15 -13.95 -12.90 -4.45 -2.90 -5.70 -3.60 -10.15 -5.55 -6.90 -3 -12.65 -4.05 -22.15 -4.05 -8 0.05 -11.55 0.55 -17.65 2.55 -2.25 0.75 -3.20 1.15 -7.45 3.05 -6.65 2.95 -16 10.80 -21.10 17.70 -2.40 3.15 -6.75 11.15 -8.10 14.70 -0.95 2.60 -1.40 4.20 -1.90 6.50 -0.30 1.40 -0.75 3.55 -1.05 4.85 -0.65 3.05 -0.65 15.75 0 18.80 0.30 1.30 0.75 3.50 1.05 4.85 1.35 6.55 5.85 15.95 10.40 22 0.45 0.55 2.95 3.15 5.55 5.75 6.95 7 14.10 11.40 23.25 14.40 3.15 1.05 7.35 1.95 10.25 2.30 3.30 0.40 16.25 -0.15 18.75 -0.75z" />
    </g>
  </svg>
)

export default StoreDaraz
